<template>
    <b-popover :target="target" :placement="placement" triggers="focus" custom-class="h-a-popover-password">
        <ul class="fa-ul my-2 pr-4">
            <li v-if="minLength > 0" v-bind:class="[passwordRules.minLength ? 'text-success' : 'text-danger']">
                <span class="fa-li">
                    <i class="fas" v-bind:class="[passwordRules.minLength ? 'fa-check' : 'fa-times']"></i>
                </span>
                Possui {{ minLength }} {{ minLength > 1 ? 'caracteres' : 'caractere' }}
            </li>
            <li v-if="hasletter" v-bind:class="[passwordRules.hasLetter ? 'text-success' : 'text-danger']">
                <span class="fa-li">
                    <i class="fas" v-bind:class="[passwordRules.hasLetter ? 'fa-check' : 'fa-times']"></i>
                </span>
                Possui 1 letra
            </li>
            <li v-if="hasnumber" v-bind:class="[passwordRules.hasNumber ? 'text-success' : 'text-danger']">
                <span class="fa-li">
                    <i class="fas" v-bind:class="[passwordRules.hasNumber ? 'fa-check' : 'fa-times']"></i>
                </span>
                Possui 1 número
            </li>
        </ul>
    </b-popover>
</template>

<script>
    export default {
        props: {
            value: {
                type: String,
            },
            target: {
                type: [String, Object],
                required: true,
            },
            placement: {
                type: String,
                default: "left",
            },
            minlength: {
                type: [Number, String],
                default: 0,
            },
            hasletter: {
                type: Boolean,
                default: false,
            },
            hasnumber: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                passwordRules: {
                    minLength: false,
                    hasLetter: false,
                    hasNumber: false,
                },
            }
        },
        computed: {
            minLength: function () {
                return parseInt(this.minlength);
            }
        },
        watch: {
            value: function(val)
            {
                // Testar tamanho (minimo de 8)
                this.passwordRules.minLength = (val && this.minLength > 0 && val.length >= this.minLength);

                // Testar se possui letra
                this.passwordRules.hasLetter = (val && this.hasletter && /^(?=.*[a-zA-Z]).+$/g.test(val));

                // Testar se possui número
                this.passwordRules.hasNumber = (val && this.hasnumber && /^(?=.*\d).+$/g.test(val));
            },
        }
    }
</script>

<style lang="stylus">
    .h-a-popover-password
        font-size 1rem
</style>